import styled from 'styled-components';
export const DrawerContainer = styled.div `
  display: flex;
  flex-direction: column;

  .drawer-download_description {
    font-size: var(--font-size-sm);
  }

  .drawer-download_body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
`;
export const TabsContainer = styled.div `
  .tab {
    overflow: hidden;
    background-color: var(--color-contrast-white);
    width: 100vw;

    .active {
      border-bottom: 4px solid var(--color-action-hover);
      font-weight: var(--font-weight-semibold);
    }
  }

  .tab button {
    background-color: inherit;
    float: left;
    border: none;
    cursor: pointer;
    padding: 14px 16px;
    width: 150px;
    font-size: var(--font-size-sm);

    :hover {
      background-color: var(--color-brand-100);
      border-bottom: 4px solid var(--color-brand-100);
    }
  }

  .tabcontent {
    padding: var(--spacing-size-xs);
    border-top: none;
    width: 622px;
    overflow: auto;
    height: calc(100vh - 300px);
  }
`;
//# sourceMappingURL=style.js.map